import { render, staticRenderFns } from "./common-info-modal.vue?vue&type=template&id=5dd46292"
import script from "./common-info-modal.vue?vue&type=script&lang=js"
export * from "./common-info-modal.vue?vue&type=script&lang=js"
import style0 from "./common-info-modal.vue?vue&type=style&index=0&id=5dd46292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports